import { useLayoutEffect, useRef, useState } from 'react';
import { CERT_WIDTH } from './TekWissenCertificate';

// Shrinks the fixed-width certificate to fit narrow screens without reflowing its layout
export const ScaledCertificate = ({ children }) => {
  const outer = useRef(null);
  const inner = useRef(null);
  const [box, setBox] = useState({ scale: 1, height: undefined });

  useLayoutEffect(() => {
    const update = () => {
      if (!outer.current || !inner.current) return;
      const scale = Math.min(1, outer.current.clientWidth / CERT_WIDTH);
      setBox({ scale, height: inner.current.offsetHeight * scale });
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(outer.current);
    ro.observe(inner.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={outer} className="mx-auto w-full overflow-hidden rounded-xl shadow-[0_30px_80px_-30px_rgba(15,23,42,0.35)]" style={{ maxWidth: CERT_WIDTH, height: box.height }}>
      <div ref={inner} style={{ width: CERT_WIDTH, transform: `scale(${box.scale})`, transformOrigin: 'top left' }}>
        {children}
      </div>
    </div>
  );
};
